export default __webpack_public_path__ + "static/media/setings.04abbaf7.png";